<template>
  <div class="main-modal main-modal_responsible" v-if="specialists" @click.stop>
    <div class="main-modal__title">{{ $t("request.responsibleTitle") }}</div>

    <div class="responsible__body" v-if="filteredItems">
      <div class="userlist__block">
        <div class="userlist__items mt20">
          <transition-group name="list" tag="div">
            <template v-for="(user, index) in filteredItems">
              <div
                class="userlist__item"
                :key="`${user.id}-${user.time}`"
                @click="addResponsible(user)"
                v-if="canShow(user.time)"
              >
                <div class="userlist__block-text">{{ index + 1 }}</div>
                <div
                  class="userlist__item-img userlist__item-img--noborder"
                  v-if="hasMatch(user) !== -1"
                >
                  <img src="/images/icon/selected.svg" alt />
                </div>
                <div
                  class="userlist__item-img"
                  :style="{ backgroundImage: getImageURL(user.image) }"
                  v-else
                ></div>
                <div class="userlist__item-name" :title="`${user.first_name} ${user.last_name}`">
                  {{ user.first_name }} {{ user.last_name }}
                  <span
                    style="font-family:'crosten-bold'"
                  >
                    ( {{ user.time }} )
                  </span>
                </div>
                <div class="userlist__item-recommended" v-if="user.intersect_tags">
                  <p v-for="skill in user.skills" :key="skill">{{skill}}</p>
                </div>

                <!-- <div class="userlist__item-post" :title="user.service.name">
                  {{ user.service.name }}
                </div>-->
                <!--
                <div
                  class="userlist__item-status"
                  :class="{ 'userlist__item-status--busy': user.is_busy }"
                ></div>-->
              </div>
            </template>
          </transition-group>
          <!-- <div class="userlist__item" v-if="filteredItems.length === 0">
              {{ $t("lists.listEmpty") }}
          </div>-->
        </div>
      </div>
    </div>

    <div class="responsible__buttons">
      <button class="main-button main-button_cancel" @click="closeModal">{{ $t("global.cancel") }}</button>
      <button
        class="main-button main-button_success"
        @click="confirmResponsible"
      >{{ $t("global.add") }}</button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'

export default {
    name: 'add-responsible',
    props: [
        'close',
        'confirm',
        'responsibleData',
        'serviceId',
        'hide',
        'tags',
        'params',

        'service_id',
        'office_id',
        'duration',
        'date',
        'address',
    ],
    data() {
        return {
            isActive: 'masters',
            selectSetting: {
                placeholder: this.$t('request.servicesHold'),
            },
            search: '',
            selectData: '',
            userlistHide: this.hide,
            defaultImage: '/images/default-user.svg',
            selectedId: '',
            time: '',
            defaultExecutorsQuantity: null,
        }
    },

    computed: {
        ...mapGetters({
            masters: 'getMasters',
            engineers: 'getEngineers',
            specialists: 'specialists/getSpecialists',
            services: 'servicesGettersWithAll',
        }),
        filteredItems() {
            return this.$store.state.specialists.recommendedMasters
        },
    },
    methods: {
        ...mapActions({
            fetch: 'specialists/getSpecialistsData',
            fetchRecommendedMasters: 'specialists/fetchRecommendedMasters',
        }),
        hasMatch(data) {
            return this.responsibleData.findIndex((item) => {
                item.time = item.time ? item.time : this.time

                return item.id === data.id && item.time === data.time
            })
        },
        canShow(selectedTime) {
            if (this.responsibleData.length === 0) {
                return true
            }

            if (!this.time) {
                return true
            }

            return this.time === selectedTime
        },
        getDuration() {
            const time = this.duration.split(':')

            const hour = parseInt(time[0]) * 60
            const min = parseInt(time[1])
            return hour + min
        },
        getImageURL(image) {
            return `url(${image === null ? this.defaultImage : image}`
        },
        changeView(view) {
            this.isActive = view
            this.fetch({ type: this.isActive })
        },
        addResponsible(data) {
            const index = this.responsibleData.findIndex((item) => item.id === data.id)
            const responsible = this.responsibleData[index]

            if (index === -1) {
                this.responsibleData.push({ ...data, small_image: data.image })
                this.time = data.time
            } else if (index !== -1 && data.time !== responsible.time) {
                this.responsibleData.splice(index, 1)
                this.responsibleData.push({ ...data, small_image: data.image })
                this.time = data.time
            } else {
                this.responsibleData.splice(index, 1)
            }

            if (this.responsibleData.length === 0) {
                this.time = null
            }
        },
        closeModal() {
            this.$emit('close', 'cancel')
        },
        confirmResponsible() {
            const splittedTime = this.time.split(':')
            const hours = parseInt(splittedTime[0])
            const minutes = parseInt(splittedTime[1])

            this.$emit('confirm', {
                data: this.responsibleData,
                hours,
                minutes,
                hasChanged: this.defaultExecutorsQuantity !== this.responsibleData.length,
            })
            this.$emit('close')
        },
    },
    mounted() {
        this.time = moment(this.date || moment()).format('HH:mm')
        this.defaultExecutorsQuantity = this.responsibleData.length
        this.tags = this.tags || []
        this.tags = this.tags.map((item) => item.id)

        this.fetchRecommendedMasters({
            service_id: this.service_id,
            office_id: this.office_id,
            date: moment(this.date).format('YYYY-MM-DD'),
            duration: this.getDuration(),
            longitude: parseFloat(this.address.longitude),
            latitude: parseFloat(this.address.latitude),
            filter: {
                tags: this.tags,
            },
        })
    },
}
</script>
<style lang="scss" scoped>
@import "src/assets/sass/main";

.userlist__item-recommended {
  margin-left: auto;
  margin-right: 30px;
  color: #000;
  font-weight: bold;
  border-radius: 4px;
  display: flex;

  p {
    padding: 5px 10px;
    background-color: var(--bg-color-green);
    margin: 8px;
    user-select: none;
  }
}

.responsible {
  padding: 64px;
  @include respond(smallhight) {
    padding: 40px;
  }
  &__title {
    font-size: 36px;
    color: $primaryColor;
    font-family: $fontMedium;
    text-align: center;
    margin-bottom: 64px;
    @include respond(smallhight) {
      margin-bottom: 40px;
    }
  }
  &__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 36px;
    &-search {
      max-width: 200px;
      border: solid 1px #e0e0e0;
    }
    &-select {
      max-width: 200px;
    }
  }
  &__body {
    width: 100%;
    height: 80%;
    overflow: scroll;
    margin-bottom: 48px;
    box-shadow: 0 2px 22px -10px #3e3e3e inset;
    border-radius: 8px;
    @include respond(smallhight) {
      margin-bottom: 30px;
    }
  }
  &__buttons {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 376px;
    margin-left: auto;
    margin-right: auto;
    & .button {
      width: 156px;
      color: $secondColor;
    }
  }
}

// .userlist {
// border-radius: 8px;
// background-color: #ffffff;
// width: 100%;
// height: calc(100% - 86px);
// position: relative;
// box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
// &__wrapper {
//    width: 100%;
//    height: 100%;
//    overflow-y: auto;
//    padding-bottom: 24px;
//    box-sizing: border-box;
// }
// &__block {
//  display: flex;
//  position: relative;
//  &-text {
//   position: absolute;
//   left: 0;
//   top: 0;
//   width: 64px;
//   flex-shrink: 0;
//   font-family: $fontLight;
// font-size: 30px;
// color: #e0e0e0;
// text-align: center;
// text-transform: uppercase;
// }
// }
// &__disabled {
// position: absolute;
// width: 100%;
// top: 0;
// left: 0;
// right: 0;
// bottom: 0;
// background-color: rgba(255, 255, 255, 0.5);
// z-index: 3;
// }
// &__items {
// flex-grow: 1;
// display: flex;
// flex-direction: column;
// position: relative;
// }
// &__item {
// position: relative;
// display: flex;
// align-items: center;
// height: 50px;
// width: 100%;
// flex-grow: 1;
// transition: 0.5s;
// padding-left: 64px;
// box-sizing: border-box;

// &:hover {
// background-color: rgba(#71bd4a, 0.15);
// & .userlist__item-button {
// opacity: 1;
// }
// }
// &-img {
// width: 36px;
// height: 36px;
// background-position: center;
// background-size: cover;
// border: 1px solid $secondColor;
// border-radius: 50%;
// margin-right: 16px;
// margin-left: 5px;
// &--noborder {
// border-color: transparent;
// }
// }
// &-name {
// font-size: 16px;
// color: #4d4d4d;
// font-family: $fontBold;
// flex-grow: 1;
// width: 10%;
// padding-left: 1px;
// padding-right: 1px;
// white-space: nowrap;
// overflow: hidden;
// text-overflow: ellipsis;
// }
// &-post {
// font-size: 12px;
// color: #4d4d4d;
// flex-grow: 1;
// width: 20%;
// padding-left: 1px;
// padding-right: 1px;
// white-space: nowrap;
// overflow: hidden;
// text-overflow: ellipsis;
// }

// &-status {
// width: 10px;
// height: 10px;
// border-radius: 50%;
// background-color: $primaryColor;
// margin-left: 23px;
// margin-right: 23px;
// &--busy {
// background-color: $secondColor;
// }
// }
// &-buttons {
// display: flex;
// align-items: center;
// flex-grow: 3;
// }
// }
// }
.border {
  border: 1px solid $primaryColor !important;
}

.list-enter-active {
  transition: all 0.5s;
}
.list-leave-active {
  transition: all 0.5s;
  position: absolute;
  // transform: translateY(-30px);
}
.list-enter,
.list-leave-to {
  opacity: 0;
  transform: translateY(30px);
}
</style>
